/*
 * The Belgian Brewer: the floating brass header tightens once the page moves.
 * Horizon scrolls .page-wrapper on wide screens and the document on narrow ones,
 * so the scroll target comes from Horizon's scroll-container helper.
 */
import { getScrollTop, getScrollEventTarget, scrollContainerMediaQuery } from '@theme/scroll-container';

const header = document.querySelector('#header-component.tbb-head');

if (header) {
  let target = null;
  let frame = 0;

  const update = () => {
    frame = 0;
    header.toggleAttribute('data-tbb-tight', getScrollTop() > 24);
  };

  const onScroll = () => {
    if (!frame) frame = requestAnimationFrame(update);
  };

  const bind = () => {
    target?.removeEventListener('scroll', onScroll);
    target = getScrollEventTarget();
    target.addEventListener('scroll', onScroll, { passive: true });
    update();
  };

  bind();
  scrollContainerMediaQuery.addEventListener('change', bind);
}
